/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const RANGE_USE_EXISTING = ({ auth }) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props

  //content

  return (
    <main>
      <p className="text_medium">
        {
          dict?.[
            "Make sure that the selected color column already has a color attribute"
          ]?.[language]
        }
      </p>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(RANGE_USE_EXISTING);
